import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { RouteErrorFallback } from '@components/errors/RouteErrorFallback'
import { ManageWellbeingReferralsPage } from '@features/wellbeing-referrals/components/ManageWellbeingReferralsPage'
import { allWellbeingReferralsQueryOptions } from '@features/wellbeing-referrals/queries'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/referrals/wellbeing/manage')({
  component: RouteComponent,
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(allWellbeingReferralsQueryOptions())
    return null
  },
  staticData: {
    crumb: {
      label: 'Manage',
    },
  },
  errorComponent: ({ error, reset }) => (
    <RouteErrorFallback
      error={error}
      onRetry={reset}
      title="An error occurred"
      description="There was an error loading wellbeing referrals."
    />
  ),
})

function RouteComponent() {
  return (
    <QueryErrorBoundary title="Failed to load wellbeing referrals" description="We couldn't load wellbeing referrals. Please try again.">
      <Suspense fallback={<LoadingIndicator resource="wellbeing referrals" />}>
        <ManageWellbeingReferralsPage />
      </Suspense>
    </QueryErrorBoundary>
  )
}
